import { GameStatus } from '@adgf/shared';
import type { GameManifest } from '@adgf/shared';

/**
 * Game Manifest for "Memory Challenge".
 *
 * The single source of truth for this game's metadata. The Dynamic Game
 * Loader reads it to decide which runtime to load and how to configure
 * the session / analytics.
 */
const manifest: GameManifest = {
  id: '33333333-3333-3333-3333-333333333333',
  slug: 'memory-challenge',
  title: 'Memory Challenge',
  description:
    'Memorise the flashing pattern of symbols, then repeat it in order. Consecutive successes raise the bar.',
  version: '0.1.0',
  template_id: null,
  runtime: 'phaser',
  status: GameStatus.DRAFT,
  difficulty: 'medium',
  duration: 60,
  features: ['memory', 'sequence', 'difficulty-ramp', 'retry', 'touch-support'],
  entrypoint: '@adgf/game-memory-challenge',
  analytics_schema: {
    sequence_length: 'number',
    correct_choice: 'number',
    wrong_choice: 'number',
    round_clear: 'number',
  },
};

export default manifest;
